import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-bookmark-add",
  templateUrl: "./med-icon-bookmark-add.component.html",
})
export class MedIconBookmarkAddComponent extends SvgMixinComponent {}
